export default __webpack_public_path__ + "static/media/skirmishers_sanctum.5fa6bde8.jpg";